<template>
  <v-dialog
    :value="show"
    max-width="800"
    persistent
    @input="onClose"
    @click:outside.stop
  >
    <v-card>
      <v-card-title class="text-h5 primary white--text">
        AI Memory Updates
        <v-spacer></v-spacer>
        <v-btn icon dark @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4 mt-2">
        <div v-if="memoryData && memoryData.length > 0">
          <v-expansion-panels>
            <v-expansion-panel
              v-for="(update, index) in memoryData"
              :key="index"
            >
              <v-expansion-panel-header class="py-2">
                <div class="d-flex align-center">
                  <v-icon
                    left
                    :color="update.is_new_fact ? 'success' : 'info'"
                    class="mr-2"
                  >
                    {{ update.is_new_fact ? 'mdi-plus-circle' : 'mdi-pencil' }}
                  </v-icon>
                  <div>
                    <span class="text-subtitle-1 font-weight-medium">
                      {{
                        update.is_new_fact
                          ? 'New Fact about'
                          : 'Updated Fact about'
                      }}:
                    </span>
                    <span
                      class="ml-2 font-weight-bold primary--text text-capitalize"
                    >
                      {{ mapMemorableEntity(update.entity_type) }}
                    </span>
                    <span
                      v-if="update.entity_id"
                      class="ml-2 text-caption grey--text"
                    >
                      ID: {{ update.entity_id }}
                    </span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat class="mb-3">
                  <v-card-text class="py-2">
                    <div class="d-flex justify-space-between">
                      <div class="d-flex">
                        <v-chip
                          small
                          class="mr-2"
                          :color="getConfidenceColor(update.confidence)"
                          text-color="white"
                        >
                          Confidence: {{ update.confidence }}/10
                        </v-chip>
                        <v-chip
                          small
                          :color="getImportanceColor(update.importance)"
                          text-color="white"
                        >
                          Importance: {{ update.importance }}/10
                        </v-chip>
                      </div>
                    </div>
                    <v-divider class="my-3"></v-divider>

                    <div class="text-subtitle-2 font-weight-bold">Fact</div>
                    <v-card outlined class="pa-3 mt-1 mb-3 fact-card">
                      {{ update.fact }}
                    </v-card>

                    <div class="text-subtitle-2 font-weight-bold">
                      Update Reason
                    </div>
                    <v-card outlined class="pa-3 mt-1 mb-3">
                      {{ update.update_reason }}
                    </v-card>

                    <div v-if="update.sources && update.sources.length > 0">
                      <div class="text-subtitle-2 font-weight-bold">
                        Sources
                      </div>
                      <v-card
                        v-for="(source, sourceIndex) in update.sources"
                        :key="sourceIndex"
                        outlined
                        class="pa-3 mt-1 mb-2 grey lighten-4"
                      >
                        <div
                          v-if="source.policy_id"
                          class="text-caption primary--text mb-1"
                        >
                          Policy ID: {{ source.policy_id }}
                        </div>
                        <div class="font-italic">"{{ source.quote }}"</div>
                      </v-card>
                    </div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div v-else class="text-center pa-5">
          <v-icon large color="grey lighten-1">mdi-information-outline</v-icon>
          <div class="mt-2 grey--text">No memory updates available</div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AiMemoryUpdatesDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    memoryData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    mapMemorableEntity(entity) {
      if (entity === 'company') return 'tenant'
      if (entity === 'property') return 'listing'
      return entity
    },
    getConfidenceColor(confidence) {
      if (!confidence) return 'grey'
      const value = parseInt(confidence)
      if (value >= 8) return 'success'
      if (value >= 5) return 'warning'
      return 'error'
    },
    getImportanceColor(importance) {
      if (!importance) return 'grey'
      const value = parseInt(importance)
      if (value >= 8) return 'deep-purple'
      if (value >= 5) return 'blue'
      return 'cyan'
    },
  },
}
</script>

<style scoped>
.fact-card {
  white-space: pre-wrap;
}
</style>
